import { render } from "./home-hotlead.vue?vue&type=template&id=220bfb78"
import script from "./home-hotlead.js?vue&type=script&lang=js"
export * from "./home-hotlead.js?vue&type=script&lang=js"

import "./home-hotlead.vue?vue&type=style&index=0&id=220bfb78&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__